// // import React from 'react'

// // import "./style.css"
// // import { motion } from "framer-motion"

// // const Cover    = () => {
// //   return (
// //     <>
// // <div ClassName='image'  >
// // <motion.div initial ={{x:0}}
// // animate={{x:[400,0]}}
// // transition={{ repeat: 0, duration: 2, delay:0.1}}>
// //     <h1>    Welcome to our Department Page</h1>
// //     <em>Examples of cleaness is Right Here...</em>
// //     </motion.div>
// // </div>

// // </>
// //   )
// // }

// // export default Cover
// import React from "react";
// import { motion } from "framer-motion";
// import Stylecover from "./cover.module.css";

// const Cover = ({ backgroundImage, heading, subHeading }) => {
//   return (
//     <div
//       className={Stylecover.container}
//       style={{
//         backgroundImage: `url(${backgroundImage})`, // override the background
//       }}
//     >
//       <div className={Stylecover.textline}>
//         {/* SVG Border Animation */}
//         <motion.svg
//           width="100%"
//           height="100%"
//           viewBox="0 0 500 150"
//           style={{
//             position: "absolute",
//             top: -10,
//             left: -10,
//             width: "calc(100% + 20px)",
//             height: "calc(100% + 20px)",
//             zIndex: 0,
//           }}
//         >
//           <motion.rect
//             x="0"
//             y="0"
//             width="100%"
//             height="100%"
//             rx="20"
//             ry="20"
//             stroke="#5D87FF"
//             strokeWidth="3"
//             fill="none"
//             initial={{ pathLength: 0 }}
//             animate={{ pathLength: 1 }}
//             transition={{ duration: 2.5, ease: "easeInOut", delay: 0.2 }}
//           />
//         </motion.svg>

//         {/* Text Box */}
//         <motion.div
//           className={Stylecover.text}
//           style={{ position: "relative", zIndex: 1 }}
//         >
//           <motion.h1
//             initial={{ opacity: 0, scale: 0.3 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 1.2, ease: "easeOut", delay: 0.2 }}
//           >
//             {heading}
//           </motion.h1>

//           <motion.h3
//             initial={{ opacity: 0, x: 100 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 1, delay: 1.5 }}
//           >
//             {subHeading}
//           </motion.h3>
//         </motion.div>
//       </div>

//       <div class={Stylecover.shape}>
//         <svg viewBox="0 0 2880 90">
//           <path
//             d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
//             fill="currentColor"
//           ></path>
//         </svg>
//       </div>
//     </div>
//   );
// };

// export default Cover;

import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Stylecover from "./cover.module.css";

const Cover = ({ images, heading, subHeading, interval = 4000 }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const slider = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(slider);
  }, [images.length, interval]);

  return (
    <div
      className={Stylecover.container}
      style={{
        backgroundImage: `url(${images[current]})`,
        transition: "background-image 1s ease-in-out",
      }}
    >
      <div className={Stylecover.textline}>
        <motion.svg
          width="100%"
          height="100%"
          viewBox="0 0 500 150"
          style={{
            position: "absolute",
            top: -10,
            left: -10,
            width: "calc(100% + 20px)",
            height: "calc(100% + 20px)",
            zIndex: 0,
          }}
        >
          <motion.rect
            x="0"
            y="0"
            width="100%"
            height="100%"
            rx="20"
            ry="20"
            stroke="#5D87FF"
            strokeWidth="3"
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2.5, ease: "easeInOut", delay: 0.2 }}
          />
        </motion.svg>

        <motion.div
          className={Stylecover.text}
          style={{ position: "relative", zIndex: 1 }}
        >
          <motion.h1
            initial={{ opacity: 0, scale: 0.3 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.2, ease: "easeOut", delay: 0.2 }}
          >
            {heading}
          </motion.h1>
          <motion.h3
            initial={{ opacity: 0, x: 100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 1.5 }}
          >
            {subHeading}
          </motion.h3>
        </motion.div>
      </div>
      <div className={Stylecover.shape}>
        <svg viewBox="0 0 2880 90">
          <path
            d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
      <div className={Stylecover.shadow} /> {/* Bottom glow shadow */}
      {/* Dots */}
      <div className={Stylecover.dots}>
        {images.map((_, index) => (
          <span
            key={index}
            onClick={() => setCurrent(index)}
            className={`${Stylecover.dot} ${
              index === current ? Stylecover.activeDot : ""
            }`}
          ></span>
        ))}
      </div>
    </div>
  );
};

export default Cover;
